import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button, Figure } from "react-bootstrap";

const ModalCrud = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [isSearchingUser, setSearchingUser] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [userId, setUserId] = useState();
  const [docNumber, setDocNumber] = useState();
  const [lastname, setLastName] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [birthDate, setBirthDate] = useState();
  const [startDate, setStartDate] = useState();
  const [grade, setGrade] = useState();
  const [gradeType, setGradeType] = useState();
  const [dojo, setDojo] = useState();
  const [examDate, setExamDate] = useState();
  const [idAikikai, setIdAikikai] = useState();
  const [dateAikikai, setDateAikikai] = useState();
  const [responsibleDocNumber, setResponsibleDocNumber] = useState();
  const [createdByUser, setCreatedByUser] = useState();

  const [grades, setGrades] = useState([]);

  const exam = props.exam;
  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));

  var moment = require("moment");

  useEffect(() => {
    setGrades(props.grades);
    setGrade(props.grades[0].id);

    if (exam) {
      setDocNumber(exam.attributes.docNumber);
      changeGrade(exam.attributes.grade_id);
      setDojo(exam.attributes.dojo_id);
      setCreatedByUser(exam.attributes.createdByUser);
      setIdAikikai(exam.attributes.idAikikai);
      setDateAikikai(exam.attributes.dateAikikai);
      setExamDate(exam.attributes.date);

      getUserByDocNumber(exam.attributes.docNumber);
      setResponsibleDocNumber(exam.attributes.responsibleDocNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return (
      !docNumber ||
      docNumber === "" ||
      !lastname ||
      lastname === "" ||
      !name ||
      name === "" ||
      !birthDate ||
      birthDate === "" ||
      !startDate ||
      startDate === "" ||
      !email ||
      email === "" ||
      !dojo ||
      dojo === "" ||
      !grade ||
      grade === "" ||
      !responsibleDocNumber ||
      responsibleDocNumber === ""
    );
  }

  const clearUserData = () => {
    setUserId(null);
    setLastName(null);
    setName(null);
    setEmail(null);
    setBirthDate("");
    setStartDate("");
  };

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  async function getUserByDocNumber(value) {
    const docNumber = value.replace(/\D/g, "");
    setDocNumber(docNumber);
    if (docNumber && docNumber.length > 6) {
      setSearchingUser(true);
      setErrorMessage(null);

      clearUserData();
      // es EDIT y deberia tener tempUser asociado
      if (exam && exam.attributes.tempUser?.data?.id) {
        const tempUser = exam.attributes.tempUser;

        setUserId(tempUser.data.id);
        setDocNumber(tempUser.data.attributes.docNumber);
        setLastName(tempUser.data.attributes.lastname);
        setName(tempUser.data.attributes.name);
        setEmail(tempUser.data.attributes.email);
        setBirthDate(tempUser.data.attributes.birthDate);
        setStartDate(tempUser.data.attributes.startDate);
      }

      // Buscar los datos en users para usar los examenes luego
      await axios
        .get(
          `${API_URL}/users/?populate=exams.grade&filters[docNumber][$eq]=${docNumber}`,
          headerRequest
        )
        .then((res) => {
          const userData = res.data[0];
          if (userData) {
            // si es ALTA uso estos para completar
            if (!exam || exam == null) {
              setDocNumber(userData.docNumber);
              setLastName(userData.lastname);
              setName(userData.name);
              setEmail(userData.email);
              setBirthDate(userData.birthDate);
              setStartDate(userData.startDate);
            }
            // to-do: Limitar graduaciones posibles a las que le falta
            //const userExams = userData.exams;
            //if (userExams && userExams.length > 0) {}
          }
        })
        .catch((error) => {
          console.log("Error find by docNumber:", error);
        })
        .finally(() => {
          setSearchingUser(false);
        });
    } else if (name) {
      clearUserData();
    }
  }

  const changeGrade = (gradeId) => {
    setGrade(gradeId);
    const grade = props.grades.find(({ id }) => id == gradeId);
    setIdAikikai(null);
    setDateAikikai(null);
    setGradeType(grade.attributes.rank);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (moment(startDate, true).diff(moment(examDate, true), "days") > 0) {
      setLoading(false);
      setErrorMessage("Fecha del Examen debe ser posterior al Inicio.");
      return;
    }

    if (
      dateAikikai != "" &&
      moment(examDate, true).diff(moment(dateAikikai, true), "days") > 0
    ) {
      setLoading(false);
      setErrorMessage("Date Aikikai debe ser posterior al Examen.");
      return;
    }

    if (idAikikai != null && idAikikai != "") {
      if (dateAikikai === "" || dateAikikai === null) {
        setLoading(false);
        setErrorMessage(
          "Date Aikikai es obligatorio si carga el Registered No."
        );
        return;
      }
    }
    saveData(e);
  };

  const saveData = async (e) => {
    setLoading(true);

    let reqUser = {
      data: {
        docNumber,
        lastname: lastname.toUpperCase(),
        name: name.toUpperCase(),
        email: email.toLowerCase(),
        birthDate: birthDate,
        startDate: startDate,
        state: "NEW",
        createdByUser: createdByUser ? createdByUser : usuario.id,
      },
    };
    const reqExam = {
      data: {
        docNumber,
        date: examDate,
        grade_id: grade,
        dojo_id: dojo,
        idAikikai,
        dateAikikai: dateAikikai,
        responsibleDocNumber,
        state: "NEW",
        tempUser: userId,
        createdByUser: createdByUser ? createdByUser : usuario.id,
      },
    };

    // Si existe en temp-users hacer PUT, sino POST
    if (exam) {
      await axios
        .put(`${API_URL}/temp-users/${userId}`, reqUser, headerRequest)
        .then((u) => {
          axios
            .put(`${API_URL}/temp-exams/${exam.id}`, reqExam, headerRequest)
            .then(() => {
              setLoading(false);
              props.onHide(true);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with put temp-exams:", error.response);
              setErrorMessage(
                "Hubo un error, intente nuevamente. " +
                  error.response.data.error.message
              );
            });
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put temp-users:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    } else {
      await axios
        .post(`${API_URL}/temp-users`, reqUser, headerRequest)
        .then((u) => {
          reqExam.data.tempUser = u.data.data.id;
          axios
            .post(`${API_URL}/temp-exams`, reqExam, headerRequest)
            .then(() => {
              setLoading(false);
              props.onHide(true);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with post temp-exams:", error.response);
              setErrorMessage(
                "Hubo un error, intente nuevamente. " +
                  error.response.data.error.message
              );
            });
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post temp-users:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {exam ? "Editar" : "Crear"} Exámen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formDocNumber"
              className="has-feedback"
            >
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control
                type="text"
                placeholder="Núm. Documento"
                value={docNumber}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="10"
                disabled={exam ? true : false}
                onChange={(e) => getUserByDocNumber(e.target.value)}
              />
              {isSearchingUser ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Apellido"
                defaultValue={lastname}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formName">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nombres"
                defaultValue={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha Nacim.</Form.Label>
              <Form.Control
                type="date"
                name="birthDate"
                min="1930-01-01"
                max="2050-12-31"
                defaultValue={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formStartDate">
              <Form.Label>Fecha Ingreso</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                min="1950-01-01"
                max="2050-12-31"
                defaultValue={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDojo">
              <Form.Label>Dojo</Form.Label>
              <Form.Select
                value={dojo}
                onChange={(e) => setDojo(e.target.value)}
              >
                <option>seleccione dojo</option>
                {props.dojos.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.attributes.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
          <hr />
          <Row className="mb-1">
            <h5>Datos del Exámen</h5>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Graduación</Form.Label>
              {grades.length > 0 ? (
                <Form.Select
                  value={grade}
                  onChange={(e) => changeGrade(e.target.value)}
                >
                  {grades.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.attributes.name}
                      </option>
                    );
                  })}
                </Form.Select>
              ) : (
                <Form.Control
                  readOnly
                  isInvalid
                  disabled
                  value="Sin opciones"
                />
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha de Examen</Form.Label>
              <Form.Control
                type="date"
                name="examDate"
                min="1950-01-01"
                max="2020-12-31"
                defaultValue={examDate}
                onChange={(e) => setExamDate(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formResponsibleDocNumber">
              <Form.Label>Examinador</Form.Label>
              <Form.Select
                value={responsibleDocNumber}
                onChange={(e) => setResponsibleDocNumber(e.target.value)}
              >
                <option>seleccione examinador</option>
                {props.teachers.map((item) => {
                  return (
                    <option
                      key={item.attributes.docNumber}
                      value={item.attributes.docNumber}
                    >
                      {item.attributes.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
          {gradeType && gradeType === "DAN" ? (
            <>
              <Row className="mb-1">
                <h6>Datos de la Yudansha</h6>
                <p>Puede cargar los datos que se registraron en la yudansha</p>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGrade">
                  <Form.Label>Registered No.</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Número de registro"
                    value={idAikikai}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onChange={(e) => setIdAikikai(e.target.value)}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="formBirthDate">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="dateAikikai"
                    value={dateAikikai}
                    min="1950-01-01"
                    max="2050-12-31"
                    onChange={(e) => setDateAikikai(e.target.value)}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Figure>
                  <Figure.Caption>
                    <b>Datos e imagen de ejemplo:</b>
                    <br />
                    Shodan (1 DAN), 147963 y 05/08/2013
                  </Figure.Caption>
                  <Figure.Image alt="yudansha" src="yudansha.jpg" />
                </Figure>
              </Row>
            </>
          ) : null}
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ModalCrud;
